import styled from 'styled-components';

export const StyledButton = styled.a<{ isMobile?: boolean }>`
  background-color: #003460;
  color: white;
  border-radius: 8px;
  padding: ${props => props.isMobile ? '6px 12px' : '12px 24px'};
  font-family: Lexend-Bold;
  font-size: ${props => props.isMobile ? '14px' : '16px'};
  line-height: 24px;
  font-weight: 700;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  transition: background-color 0.2s ease;

  span {
    color: #FDB517;
  }

  &:hover {
    background-color: #18A9E1;

    span {
      color: white;
    }
  }
`;

export const StyledNavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;

  svg path {
    transition: fill 0.2s ease;
  }

  &:hover {
    svg path {
      fill: #18A9E1;
    }
  }
`

export const AdditionalResourcesSection = styled.section`
  padding: 56px 52px;
  background-color: #E6F9FF;
  border-top: 4px solid #FDB515;
  width: 100%;

  @media (max-width: 600px) {
    padding: 56px 12px;
  }
`;

export const AdditionalResourcesContainer = styled.div`
  max-width: 1408px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;

export const ReputationSection = styled.section`
  padding: 56px 52px;
  background-color: #FFFFFF;
  border-bottom: 4px solid #FDB515;
  width: 100%;

  @media (max-width: 600px) {
    padding: 56px 12px;
  }
`;

export const ReputationContainer = styled.div`
  max-width: 1528px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;

export const SectionTitle = styled.h1`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  color: #003460;
  font-size: 32px;
  font-family: Lexend-Bold;
  line-height: 40px;
`;

export const SectionTitleHighlight = styled.span`
  color: #18A9E1;
`;

export const AssetsGrid = styled.div`
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  justify-content: center;
  img {
    width: 280px;
  }
  
  @media (max-width: 900px) {
    gap: 28px;
  }

  @media (max-width: 600px) {
    gap: 14px;

    img, a {
      width: 45%;
    }
  }
`;

export const ResourceDescription = styled.p`
  color: #666666;
  font-size: 20px;
  font-family: Lexend-Bold;
  line-height: 28px;
  text-align: center;
  transition: color 0.3s ease-in-out;

  @media (max-width: 600px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const ResourceItem = styled.a`
  padding: 32px;
  border-radius: 8px;
  border: 1px #18A9E1 solid;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  display: flex;
  flex: 1 0;
  text-decoration: none;
  transition: background-color 0.3s ease-in-out;

  svg path {
    transition: fill 0.3s ease-in-out;
  }

  &:hover {
    background-color: #003460;
    border: 1px #FDB515 solid;

    ${ResourceDescription} {
      color: white;
    }

    svg path {
      fill: white;
    }
  }
`;

export const FooterSection = styled.footer`
  padding: 48px 0;
  background-color: #40474F;
  width: 100%;
`;

export const FooterContainer = styled.div`
  max-width: 1408px;
  margin: 0 auto;
  padding: 0 24px;
`

export const FooterLogoArea = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  
  hr {
    border-color: #FFFFFF;
  }
  
  p {
    color: #FFFFFF;
    font-size: 16px;
    font-family: Lexend-Medium;
    line-height: 24px;
  }
`

export const FooterNavigation = styled.div`
  display: flex;
  gap: 28px;
  margin: 80px 0;
  justify-content: space-between;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 40px;
  }
`

export const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px 200px;

  @media (max-width: 900px) {
    gap: 28px 100px;
  }

  a {
    color: #FFFFFF;
    font-size: 16px;
    font-family: Lexend-Medium;
    text-transform: uppercase;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const FooterContactInfo = styled.div`
  display: flex;
  gap: 180px;
  color: #FFFFFF;

  @media (max-width: 900px) {
    gap: 90px;
  }

  h3 {
    font-size: 16px;
    font-family: Lexend-Bold;
    text-transform: uppercase;
  }
  
  p {
    font-size: 16px;
    font-family: Lexend;
    line-height: 28px;
    margin-bottom: 32px;
  }

  a {
    color: #FFFFFF;
    font-size: 16px;
    font-family: Lexend;
    line-height: 28px;
  }
`

export const FooterSocialLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const FooterLegalNotice = styled.div`
  color: #FFFFFF;
  font-size: 11px;
  font-family: Lexend;
  line-height: 1.5;

  a {
    color: #FFFFFF;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

  }

  span {
    display: inline-block;
    margin: 0 8px;
  }
`